import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $FlyoutCategoriesModuleName } from "./flyoutCategories.types";

const getFlyoutCategories = (state: IState) =>
    getValueState(state, $FlyoutCategoriesModuleName);

export { getFlyoutCategories };
